import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { call, put, takeLatest } from "redux-saga/effects";
import { Tracker } from "../../../util/analytics";
import {
  API_ENDPOINTS,
  REACT_APP_MOCK_DATA_ENABLED,
} from "../../../util/constants";
import {
  createHeaders,
  createHeadersWithAuth,
  requestPromise,
  requestPromiseObj
} from "../../../util/request";

import axios from "axios";

import moment from "moment";
import { updateUserStatus } from "./userProfileSlice";
import * as helpers from "../../../util/helpers";

export const i_smsProviders = [
  { value: "JustDial", label: "Just Dial" },
  { value: "Sulekha", label: "Sulekha" },
];
export const i_smsActionsTaken = [
  { value: "2", label: "Called by Agent" },
  { value: "1", label: "SMSed Back" },
  { value: "0", label: "No Action Taken" },
];

export const i_call_action = [
  { value: "all", label: "All Calls" },
  { value: "DTMF", label: "DTMF" },
  { value: "Voicemail", label: "Voicemail" },
  { value: "Phone", label: "Phone" },
  { value: "DNP", label: "Blacklist" },
  { value: "Missed Call", label: "Missed Call" },
  { value: "Sound", label: "Sound" },
  { value: "sr_mobile_app", label: "SR Mobile App" },
];

export const i_call_duration = [
  { value: "under-30-secs", label: "Under 30 Secs" },
  { value: "under-1-min", label: "Under 1 Min" },
  { value: "1-5mins", label: "1-5 Mins" },
  { value: "5-10mins", label: "5-10 Mins" },
  { value: "more-than-10-mins", label: "More than 10 Mins" },
  { value: "custom", label: "Custom (Less than)" },
];

export const i_call_status = [
  { value: "Answered", label: "Answered" },
  { value: "Missed", label: "Missed" },
  { value: "Abandoned", label: "Abandoned" },
  { value: "Did Not Process", label: "Did Not Process" },
];

export const i_customer_status = [
  { value: "Connected", label: "Connected" },
  { value: "Customer Missed", label: "Customer Missed" },
  { value: "Did Not Process", label: "Did Not Process" },
];
export const i_agent_status = [
  { value: "Connected", label: "Connected" },
  { value: "Agent Missed", label: "Agent Missed" },
  { value: "Did Not Process", label: "Did Not Process" },
];

export const i_disposition = [];

export const i_device = [
  { value: "sr_app", label: "Phone" },
  { value: "softphone", label: "Softphone" },
];

export const i_others = [{ value: "sticky_enabled", label: "Sticky Agents" }];

export const i_lead_statuses = [
  { value: "all", label: "All" },
  { value: "Hot", label: "Hot" },
  { value: "Warm", label: "Warm" },
  { value: "Cold", label: "Cold" },
  { value: "Closed", label: "Closed" },
];

export const actionTypes = {
  Login: "[Auth] Login Action",
  LoginSuccess: "[Auth] Login Success Action",
  LoginSocial: "[Auth] LoginSocial Action",
  LoginSocialSuccess: "[Auth] LoginSocial Success Action",
  Logout: "[Auth] Logout Action",
  SetInitialStateLogout: "[Auth] On Logout Initial State",
  ForgotPassword: "[Auth] ForgotPassword Action",
  ResetPassword: "[Auth] ResetPassword Action",
  ChangePassword: "[Auth] ChangePassword Action",
  UserDetail: "[Auth] UserDetail Action",
  UserDetailSuccess: "[Auth] UserDetail Success Action",
  UserDetailSuccessRefreshed: "UserDetailSuccessRefreshed",
  UserPlans: "[Auth] User Plans Action",
  UserPlansSuccess: "[Auth] User Plans Success Action",
  UserSolutions: "[Auth] User Solutions Action",
  UserSolutionsSuccess: "[Auth] User Solutions Success Action",
  SetMainFilters: "[MainFilters] Set Filter",
  SetMainFiltersStart: "[MainFilters] Set Filter Start",
  SwitchRole: "[SwitchRole] For Testing",
  ClearMainFilters: "ClearMainFilters",
  SSOLogin: "SSOLogin",
  setSSOToken: "setSSOToken",
  setSSOStatus: "setSSOStatus",
  Set: "Set",
  Clear: "Clear",
  ApplySearch: "ApplySearch",
  CheckFiltersState: "CheckFiltersState",
  clearIncrementFilterStateCounterForCallLogs:
    "clearIncrementFilterStateCounterForCallLogs",
  incrementFilterStateCounterForSMSLogs:
    "incrementFilterStateCounterForSMSLogs",
};

const initialAuthState0 = {
  is_sms_enabled: false,
  sso_status: 0,
  sso_token: undefined,
  reloaded: undefined,
  user: undefined,
  authToken: undefined,
  lastAuthTokenRefreshedTime: undefined,
  profile: undefined,
  extra_data: {},
  plans: {},
  solutions: {},
  is_callcenter_enabled: false,
  initial_status: false,
  is_hierarchy_enabled: false,
  is_mpls: false,
  is_sso: false,
  is_disposition_enabled: false,
  is_campaign_enabled: true,
  user_status_color: undefined,
  role: undefined,
  is_transfer_to_queue: false,
  is_call_to_anynumber: false,
  is_show_custom_info: false,
  user_api_key: null,
  konnect_user_api_key: null,
  kamailio_username: "",
  kamailio_password: "",
  kamailio_wss_domain: "",
  kamailio_domain: "",
  sip_url_flag: "",
  turn_cred: null,
  fetch_turn_cred: false,
  fetch_turn_cred_type: false,
  multiagent: false,
  number_masking: false,
  number_masking_format: 0,
  remove_konnect_dependency: false,
  user_queue_list: [],
  switch_old_state: {},
  oldSr_iframe_state: "loading",
  // is_duplicated_tab: true,
  filters: {
    solutions: [],
    plans: [],
    numbers: [],
    selectedSolutionOptions: false,
    selectedPlanOptions: false,
    selectedNumberOptions: false,
    filter_type: null,
    date_filter: { code: "today" },
    from_date: null,
    to_date: null,
    from_date_fmt: null,
    to_date_fmt: null,
    refresh: null,
    smsProviders: [],
    smsActionTaken: [],
    selectedNumbersForSMS: [],
    selectedPlansForSMS: [],
    selectedNumbersOptionsForSMS: false,
    selectedPlansOptionsForSMS: false,
  },
  agentActionFilter: [],
  smsFiltersState: 0,
  smsProviders: [...i_smsProviders],
  smsActionsTaken: [...i_smsActionsTaken],
  applySearchState: 0,
  clearSearchStateForSMS: 0,
  smsFilterState: 0,
  selectedNumbersForSMS: [],
  selectedPlansForSMS: [],
  selectedNumbersOptionsForSMS: false,
  selectedPlansOptionsForSMS: false,
  callLogsQueryParams: { pageNumber: 1, pageSize: 10 },
  calllogsFiltersState: 0,
  applySearchStateForCallLogs: 0,
  clearSearchStateForCallLogs: 0,
  clearFilterStateCounterForCallLogs: 0,
  selectedSolutionsForCallLogs: [],
  selectedNumbersForCallLogs: [],
  selectedPlansForCallLogs: [],
  selectedNumbersOptionsForCallLogs: false,
  selectedPlansOptionsForCallLogs: false,
  call_action: JSON.parse(JSON.stringify([...i_call_action])),
  call_duration: JSON.parse(JSON.stringify([...i_call_duration])),
  call_status: JSON.parse(JSON.stringify([...i_call_status])),
  customer_status: JSON.parse(JSON.stringify([...i_customer_status])),
  agent_status: JSON.parse(JSON.stringify([...i_agent_status])),
  disposition: JSON.parse(JSON.stringify([...i_disposition])),
  device: JSON.parse(JSON.stringify([...i_device])),
  duration__lte_min_CallLogs: "",
  duration__lte_sec_CallLogs: "",
  selectedCompaignIds: [],
  compaigns: [],
  agent_names_call_logs_filter: [],
  agent_names_crm_filter: [],
  datepicker_crm_filter: [],
  others: JSON.parse(JSON.stringify([...i_others])),
  filter_typeForCallLogs: null,
  date_filterForCallLogs: { code: "today" },
  from_dateForCallLogs: null,
  to_dateForCallLogs: null,
  from_date_fmtForCallLogs: null,
  to_date_fmtForCallLogs: null,
  lead_statuses: JSON.parse(JSON.stringify([...i_lead_statuses])),
  applySearchStateForCRM: 0,
  crmFiltersState: 0,
  followups_changed: 0,
  customer_updated: 0,
  selectedSolutions: [],
  selectedPlans: [],
  selectedNumbers: [],
  selectedSolutionOptions: false,
  selectedPlanOptions: false,
  selectedNumberOptions: false,
  filter_type: null,
  date_filter: { code: "today" },
  from_date: null,
  to_date: null,
  from_date_fmt: null,
  to_date_fmt: null,
  refresh: null,
  clear_cnt: 1,
  agentTimer: false,
  crmCustomer: false,
  crmCustomerId: false,
  resetSMSLogsPages: 0,
  resetCallLogsPages: 0,
  resetCRMPages: 0,
  crmVia: null,
  selectedQueue: null,
  auto_answer_delay_value: null,
  auto_answer: null,
  download_sample_csv_noncc: null,
  download_sample_csv_cc: null,
  is_password_expired: false,
  is_password_expiring: false,
  password_reset_required: 90,
  pwd_exp_remaining_days: null
};

const initialAuthState = JSON.parse(JSON.stringify(initialAuthState0));

export const getKeyName = () => {
  return process.env.REACT_APP_VERSION + "-module-auth";
};

export const reducer = persistReducer(
  {
    storage,
    key: getKeyName(),
    whitelist: [
      "user",
      "lastAuthTokenRefreshedTime",
      "profile",
      "plans",
      "solutions",
      "role",
      "is_hierarchy_enabled",
      "is_callcenter_enabled",
      "is_mpls",
      "filtersdd",
      "status_color",
      "is_disposition_enabled",
      "is_sso",
      "is_sms_enabled",
      "extra_data",
      "multiagent",
      "is_transfer_to_queue",
      "is_call_to_anynumber",
      "is_show_custom_info",
      "kamailio_username",
      "kamailio_password",
      "kamailio_wss_domain",
      "kamailio_domain",
      "sip_url_flag",
      "crmCustomer",
      "crmCustomerId",
      "auto_answer_delay_value",
      "auto_answer",
      "download_sample_csv_noncc",
      "download_sample_csv_cc",
      "is_password_expired",
      "is_password_expiring",
      "password_reset_required",
      "pwd_exp_remaining_days"
    ],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.setSSOToken: {
        if (action.payload && action.payload.sso_token) {
          helpers.setCookie('authToken', action.payload.sso_token, 7);
          return { ...state, sso_token: action.payload.sso_token };
        }
        helpers.eraseCookie('authToken');
        return { ...state, sso_token: null };
      }

      case "switch_old_state": {
        if (action.payload.switch_old_state) { 
          localStorage.setItem("switch_old_state", JSON.stringify(action.payload.switch_old_state));
          return { ...state, switch_old_state: action.payload.switch_old_state }; 
        } 
        else {
          localStorage.setItem("switch_old_state", JSON.stringify(action.payload.switch_old_state));
          return { ...state, switch_old_state: action.payload.switch_old_state };
        }
        break;
      }

      case "duplicated_tab_check" : {
        if (action.payload.is_duplicated_tab) { 
          return { ...state, is_duplicated_tab: action.payload.is_duplicated_tab }; 
        } else {
          return { ...state, is_duplicated_tab: action.payload.is_duplicated_tab };
        }
        break;
      }

      case actionTypes.setSSOStatus: {
        if (action.payload && action.payload.sso_status) {
          return { ...state, sso_status: action.payload.sso_status };
        }
        return { ...state, sso_status: 0 };
      }
      case actionTypes.LoginSuccess: {
        if (action.payload && action.payload.status === 200) {
          const newState = {
            ...state,
            user: action.payload.success,
          };
          helpers.setCookie('authToken', action.payload.success.token, 7);
          const user = action.payload.success;
          Tracker.event_v2(
            "AUTH",
            "login",
            "Login success",
            "user-login-success",
            { user: user }
          );

          return newState;
        }
        helpers.eraseCookie('authToken');
        return { ...state, user: null};
      }

      case actionTypes.LoginSocialSuccess: {
        if (action.payload && action.payload.status === 200) {
          const user = action.payload.success;
          Tracker.event_v2(
            "AUTH",
            "login",
            "Google Login success",
            "user-google-login-success",
            { user: user }
          );
          helpers.setCookie('authToken', user.token, 7);
          return {
            ...state,
            user: action.payload.success,
          };
        }
        helpers.eraseCookie('authToken');
        return { ...state, user: null};
      }

      case actionTypes.UserDetailSuccess: {
        if (action.payload && action.payload.status === 200) {
          let date = new Date();
          let time = date.getTime();
          localStorage.setItem("app_env", `${process.env.REACT_APP_ENV}`);
          localStorage.setItem("user_id", action.payload.success.user_id);
          localStorage.setItem("account_id", action.payload.success.account_id);
          localStorage.setItem(
            "account_name",
            action.payload.success.account_name
          );
          localStorage.setItem("role", action.payload.success.role);
          localStorage.setItem(
            "is_callcenter_enabled",
            action.payload.success.is_callcenter_enabled
          );
          localStorage.setItem(
            "billing_type",
            action.payload.success.billing_type
          );

          moment.tz.setDefault(action.payload.success.timezone);
          if (action.payload.is_sso === true) {
            localStorage.setItem("via_sso", "YES");
          }

          return {
            ...state,
            profile: action.payload.success,
            role: action.payload.success.role,
            is_hierarchy_enabled: action.payload.success.is_hierarchy_enabled,
            is_callcenter_enabled: action.payload.success.is_callcenter_enabled,
            is_mpls: action.payload.success.is_mpls,
            lastAuthTokenRefreshedTime: time,
            is_sso: action.payload.is_sso,
            is_disposition_enabled:
              action.payload.success.is_disposition_enabled,
            status_color: action.payload.success.status_color,
            is_sms_enabled: action.payload.success.is_sms_enabled,
            is_transfer_to_queue: action.payload.success.is_transfer_to_queue,
            is_call_to_anynumber: action.payload.success.is_call_to_anynumber,
            is_show_custom_info: action.payload.success.is_show_custom_info,
            user_api_key: action.payload.success.user_api_key,
            konnect_user_api_key: action.payload.success.konnect_user_api_key,
            kamailio_username: action.payload.success.kamailio_username,
            kamailio_password: action.payload.success.kamailio_password,
            kamailio_wss_domain: action.payload.success.kamailio_wss_domain,
            kamailio_domain: action.payload.success.kamailio_domain,
            sip_url_flag:action.payload.success.sip_url_flag,
            is_obdcallcenter_activated: action.payload.success.is_obdcallcenter_activated,
            is_preview_dialer_enabled: action.payload.success.is_preview_dialer_enabled,
            dialer_type: action.payload.success.dialer_type,
            lead_dialing_ratio: action.payload.success.lead_dialing_ratio,
            multiagent: action.payload.success.multiagent,
            custom_breaks_enabled: action.payload.success.custom_breaks_enabled,
            initial_status: action.payload.success.initial_status,
            number_masking: action.payload.success.number_masking,
            user_queue_list: action.payload.success.user_queue_list,
            auto_answer_delay_value: action.payload.success.auto_answer_delay_value,
            auto_answer:action.payload.success.auto_answer,
            download_sample_csv_noncc:action.payload.success.download_sample_csv_noncc,
            download_sample_csv_cc:action.payload.success.download_sample_csv_cc,
            is_password_expired: action.payload.success.is_password_expired,
            is_password_expiring: action.payload.success.is_password_expiring,
            password_reset_required: action.payload.success.password_reset_required,
            pwd_exp_remaining_days: action.payload.success.pwd_exp_remaining_days
          };
        }
        return { ...state, profile: null };
      }

      case actionTypes.UserDetailSuccessRefreshed: {
        if (action.payload && action.payload.status === 200) {
          let date = new Date();
          let time = date.getTime();
          helpers.setCookie('user_api_key', action.payload.success.user_api_key,1);
          helpers.setCookie('konnect_user_api_key', action.payload.success.konnect_user_api_key, 1);
          return {
            ...state,
            profile: action.payload.success,
            role: action.payload.success.role,
            is_hierarchy_enabled: action.payload.success.is_hierarchy_enabled,
            is_callcenter_enabled: action.payload.success.is_callcenter_enabled,
            is_mpls: action.payload.success.is_mpls,
            lastAuthTokenRefreshedTime: time,
            is_disposition_enabled:
              action.payload.success.is_disposition_enabled,
            status_color: action.payload.success.status_color,
            is_sms_enabled: action.payload.success.is_sms_enabled,
            is_transfer_to_queue: action.payload.success.is_transfer_to_queue,
            is_call_to_anynumber: action.payload.success.is_call_to_anynumber,
            is_show_custom_info: action.payload.success.is_show_custom_info,
            user_api_key: action.payload.success.user_api_key,
            konnect_user_api_key: action.payload.success.konnect_user_api_key,
            kamailio_username: action.payload.success.kamailio_username,
            kamailio_password: action.payload.success.kamailio_password,
            kamailio_wss_domain: action.payload.success.kamailio_wss_domain,
            kamailio_domain: action.payload.success.kamailio_domain,
            sip_url_flag: action.payload.success.sip_url_flag,
            extra_data: action.payload.success.extra_data,
            is_obdcallcenter_activated: action.payload.success.is_obdcallcenter_activated,
            is_preview_dialer_enabled: action.payload.success.is_preview_dialer_enabled,
            dialer_type: action.payload.success.dialer_type,
            lead_dialing_ratio: action.payload.success.lead_dialing_ratio,
            multiagent: action.payload.success.multiagent,
            custom_breaks_enabled: action.payload.success.custom_breaks_enabled,
            initial_status: action.payload.success.initial_status,
            number_masking: action.payload.success.number_masking,
            number_masking_format: action.payload.success.number_masking_format,
            remove_konnect_dependency: action.payload.success.remove_konnect_dependency,
            user_queue_list: action.payload.success.user_queue_list,
            auto_answer_delay_value: action.payload.success.auto_answer_delay_value,
            auto_answer: action.payload.success.auto_answer,
            is_password_expired: action.payload.success.is_password_expired,
            is_password_expiring: action.payload.success.is_password_expiring,
            password_reset_required: action.payload.success.password_reset_required,
            pwd_exp_remaining_days: action.payload.success.pwd_exp_remaining_days
          };
        }
        return { ...state, profile: null };
      }

      case actionTypes.SwitchRole: {
        if (action.payload) {
          const newState = {
            ...state,
            role: action.payload.success.role,
            is_hierarchy_enabled: action.payload.success.is_hierarchy_enabled,
            is_callcenter_enabled: action.payload.success.is_callcenter_enabled,
            is_mpls: action.payload.success.is_mpls,
          };
          return newState;
        }
        return { ...state };
      }

      case actionTypes.UserPlansSuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, plans: action.payload.success };
        }
        return { ...state, plans: null };
      }

      case actionTypes.UserSolutionsSuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, solutions: action.payload.solutions };
        }
        return { ...state, solutions: null };
      }

      case "setAgentTimer": {
        let newState = { ...state, agentTimer: action.payload.agentTimer };

        return newState;
      }

      case actionTypes.SetMainFiltersStart: {
        let newState = { ...state };
        if (action.payload["changelog"]) {
          Object.keys(action.payload["changelog"]).map((k, v) => {
            newState[k] = action.payload["changelog"][k];
          });
        }
        return newState;
      }

      case "Change": {
        let newState = { ...state };
        if (action.payload) {
          Object.keys(action.payload).map((k, v) => {
            newState[k] = action.payload[k];
          });
        }

        return newState;
      }
      case actionTypes.CheckFiltersState: {
        if (action.payload && action.payload.apply) {
          if (action.payload.filter_type === "smsFiltersState") {
            let newState = { ...state, smsFiltersState: 200 };

            return newState;
          }
          if (action.payload.filter_type === "callLogsFiltersState") {
            let newState = { ...state, callLogsFiltersState: 200 };

            return newState;
          }
          if (action.payload.filter_type === "crmFiltersState") {
            let newState = { ...state, crmFiltersState: 200 };

            return newState;
          }
        }

        if (action.payload.filter_type === "crmFiltersState") {
          let crmFiltersState = 0;
          Object.keys(state.lead_statuses).map((key) => {
            if (state.lead_statuses[key].selected) {
              crmFiltersState = 200;
            }
          });

          Object.keys(state.agent_names_crm_filter).map((key) => {
            if (state.agent_names_crm_filter[key].selected) {
              crmFiltersState = 200;
            }
          });

          Object.keys(state.datepicker_crm_filter).map((key) => {
            if (state.datepicker_crm_filter[key].selected) {
              crmFiltersState = 200;
            }
          });

          if (state.crmFiltersState !== crmFiltersState) {
            return { ...state, crmFiltersState };
          }
        }
        if (action.payload.filter_type === "smsFiltersState") {
          let smsFiltersState = 0;
          if (
            state.selectedNumbersForSMS &&
            state.selectedNumbersForSMS.length > 0
          ) {
            smsFiltersState = 200;
          }

          if (
            state.selectedPlansForSMS &&
            state.selectedPlansForSMS.length > 0
          ) {
            smsFiltersState = 200;
          }

          Object.keys(state.smsProviders).map((key) => {
            if (state.smsProviders[key].selected) {
              smsFiltersState = 200;
            }
          });

          Object.keys(state.agentActionFilter).map((key) => {
            if (state.agentActionFilter[key].name) {
              smsFiltersState = 200;
            }
          });

          Object.keys(state.smsActionsTaken).map((key) => {
            if (state.smsActionsTaken[key].selected) {
              smsFiltersState = 200;
            }
          });

          if (state.smsFiltersState !== smsFiltersState) {
            return { ...state, smsFiltersState };
          }
        }

        if (action.payload.filter_type === "callLogsFiltersState") {
          let callLogsFiltersState = 0;
          if (
            state.selectedNumbersForCallLogs &&
            state.selectedNumbersForCallLogs.length > 0
          ) {
            callLogsFiltersState = 200;
          }
          if (
            state.selectedPlansForCallLogs &&
            state.selectedPlansForCallLogs.length > 0
          ) {
            callLogsFiltersState = 200;
          }
          if (state.selectedSolutionsForCallLogs) {
            Object.keys(state.selectedSolutionsForCallLogs).map((key) => {
              if (state.selectedSolutionsForCallLogs[key].selected) {
                callLogsFiltersState = 200;
              }
            });
          }
          if (state.call_action) {
            Object.keys(state.call_action).map((key) => {
              if (state.call_action[key].selected) {
                callLogsFiltersState = 200;
              }
            });
          }
          if (state.call_duration) {
            Object.keys(state.call_duration).map((key) => {
              if (state.call_duration[key].selected) {
                callLogsFiltersState = 200;
              }
            });
          }
          if (state.customer_status) {
            Object.keys(state.customer_status).map((key) => {
              if (state.customer_status[key].selected) {
                callLogsFiltersState = 200;
              }
            });
          }
          if (state.agent_status) {
            Object.keys(state.agent_status).map((key) => {
              if (state.agent_status[key].selected) {
                callLogsFiltersState = 200;
              }
            });
          }
          if (state.disposition) {
            Object.keys(state.disposition).map((key) => {
              if (state.disposition[key].selected) {
                callLogsFiltersState = 200;
              }
            });
          }
          if (state.device) {
            Object.keys(state.device).map((key) => {
              if (state.device[key].selected) {
                callLogsFiltersState = 200;
              }
            });
          }
          if (state.callLogsFiltersState !== callLogsFiltersState) {
            return { ...state, callLogsFiltersState };
          }
        }

        return state;
      }

      case actionTypes.clearIncrementFilterStateCounterForCallLogs: {
        let newState = { ...state };
        if (action.payload["module"] === "call-logs") {
          newState = {
            ...state,
            clearFilterStateCounterForCallLogs: ++state.clearFilterStateCounterForCallLogs,
          };
        }
        return newState;
      }

      case actionTypes.incrementFilterStateCounterForSMSLogs: {
        let newState = { ...state };
        if (action.payload["module"] === "smslogs") {
          newState = { ...state, resetSMSLogsPages: ++state.resetSMSLogsPages };
        }
        return newState;
      }

      case actionTypes.Set: {
        let newState = { ...state };
        if (action.payload["changelog"]) {
          Object.keys(action.payload["changelog"]).map((k, v) => {
            newState[k] = action.payload["changelog"][k];
          });
        }
        return newState;
      }

      case actionTypes.Clear: {
        let newState = null;

        if (action.payload["module"] === "crm") {
          newState = {
            ...state,
            resetCRMPages: state.resetCRMPages + 1,
            applySearchStateForCRM: ++state.applySearchStateForCRM,
          };

          if (action.payload["changelog"])
            Object.keys(action.payload["changelog"]).map((k, v) => {
              newState[k] = !action.payload["changelog"][k]
                ? initialAuthState[k]
                : action.payload["changelog"][k];
            });

          return newState;
        }

        if (action.payload["module"] === "smslogs") {
          newState = {
            ...state,
            resetSMSLogsPages: state.resetSMSLogsPages + 1,
            applySearchState: ++state.applySearchState,
            clearSearchStateForSMS: ++state.clearSearchStateForSMS,
          };
        }

        if (action.payload["module"] === "call-logs") {
          newState = {
            ...state,
            resetCallLogsPages: state.resetCallLogsPages + 1,
            applySearchStateForCallLogs: ++state.applySearchStateForCallLogs,
            clearSearchStateForCallLogs: ++state.clearSearchStateForCallLogs,
            callLogsQueryParams: { pageNumber: 1, pageSize: 10 },
          };
        }

        if (!newState) {
          newState = { ...state };
        }
        if (action.payload["changelog"]) {
          Object.keys(action.payload["changelog"]).map((k, v) => {
            newState[k] = !action.payload["changelog"][k]
              ? initialAuthState[k]
              : action.payload["changelog"][k];
          });
        }
        return newState;
      }

      case actionTypes.ApplySearch: {
        let newState = null;
        if (action.payload["module"] === "smslogs") {
          newState = {
            ...state,
            resetSMSLogsPages: state.resetSMSLogsPages + 1,
            applySearchState: ++state.applySearchState,
          };
        }

        if (action.payload["module"] === "call-logs") {
          newState = {
            ...state,
            resetCallLogsPages: state.resetCallLogsPages + 1,
            applySearchStateForCallLogs: ++state.applySearchStateForCallLogs,
            callLogsQueryParams: { pageNumber: 1, pageSize: 10 },
          };
        }

        if (action.payload["module"] === "crm") {
          newState = {
            ...state,
            resetCRMPages: state.resetCRMPages + 1,
            applySearchStateForCRM: ++state.applySearchStateForCRM,
          };
        }
        if (!newState) {
          newState = { ...state };
        }
        return newState;
      }
      case actionTypes.SetMainFilters: {
        let newState = { ...state, filters: action.payload };
        if (action.payload["changelog"]) {
          Object.keys(action.payload["changelog"]).map((k, v) => {
            newState[k] = action.payload["changelog"][k];
          });
        }
        return newState;
      }

      case actionTypes.ClearMainFilters: {
        return {
          ...state,
          clear_cnt: state.clear_cnt + 1,
          filters: {
            solutions: [],
            plans: [],
            numbers: [],
            selectedSolutionOptions: false,
            selectedPlanOptions: false,
            selectedNumberOptions: false,
            filter_type: null,
            date_filter: { code: "today" },
            from_date: null,
            to_date: null,
            from_date_fmt: null,
            to_date_fmt: null,
            refresh: null,
          },
          selectedSolutions: [],
          selectedPlans: [],
          selectedNumbers: [],
          selectedSolutionOptions: false,
          selectedPlanOptions: false,
          selectedNumberOptions: false,
          filter_type: null,
          date_filter: { code: "today" },
          from_date: null,
          to_date: null,
          from_date_fmt: null,
          to_date_fmt: null,
          refresh: null,
        };
      }
      case actionTypes.SetInitialStateLogout: {
        try {
          localStorage.clear();
          let loggedIn = state.user != null && state.user != undefined;
          if (loggedIn) return JSON.parse(JSON.stringify(initialAuthState0));
        } catch (error) {}
        return JSON.parse(JSON.stringify(initialAuthState0));
      }
      case actionTypes.Logout: {
        try {
          const authToken = helpers.getAuthToken();
          let loggedIn = state.user != null && state.user != undefined;
          if (loggedIn) {
            // localStorage.removeItem('user_id')
            // localStorage.removeItem('account_id')
            // localStorage.removeItem('account_name')
            // localStorage.removeItem('via_sso')
            const headers = {
              jwtAuthorization: authToken,
            };
            axios
              .get(`${process.env.REACT_APP_API_ENDPOINT_BASE_URL}/vr/logout`, {
                headers: headers,
              })
              .then((val) => {
                Tracker.event_v2(
                  "AUTH",
                  "logout",
                  "Logout success",
                  "site-logout-success",
                  { user: state.user }
                );
                localStorage.clear();
                helpers.eraseCookie('authToken');
                helpers.eraseCookie('konnect_user_api_key');
                helpers.eraseCookie('user_api_key');
              })
              .catch((err) => {
                Tracker.event_v2(
                  "AUTH",
                  "logout",
                  "Logout success",
                  "site-logout-success",
                  { user: state.user }
                );
                localStorage.clear();
                // helpers.eraseCookie('authToken');
              });
          }
        } catch (error) {}
        return JSON.parse(JSON.stringify(initialAuthState0));
      }
      default:
        return state;
    }
  }
);
// export const getAuthToken = () => {
//   return getCookie('authToken');
// };
export const actions = {
  login: (payload, onSuccess, onError) => ({
    type: actionTypes.Login,
    payload,
    onSuccess,
    onError,
  }),
  loginSuccess: (payload) => ({ type: actionTypes.LoginSuccess, payload }),
  loginSocial: (payload, onSuccess, onError) => ({
    type: actionTypes.LoginSocial,
    payload,
    onSuccess,
    onError,
  }),
  loginSocialSuccess: (payload) => ({
    type: actionTypes.LoginSocialSuccess,
    payload,
  }),
  forgotPassword: (payload, onSuccess, onError) => ({
    type: actionTypes.ForgotPassword,
    payload,
    onSuccess,
    onError,
  }),
  changePassword: (payload, onSuccess, onError) => ({
    type: actionTypes.ChangePassword,
    payload,
    onSuccess,
    onError,
  }),
  resetPassword: (payload, onSuccess, onError) => ({
    type: actionTypes.ResetPassword,
    payload,
    onSuccess,
    onError,
  }),
  logout: () => ({ type: actionTypes.Logout }),
  setInitialStateLogout: () => ({ type: actionTypes.SetInitialStateLogout }),
  setSSOToken: (payload) => ({ type: actionTypes.setSSOToken, payload }),
  setSSOStatus: (payload) => ({ type: actionTypes.setSSOStatus, payload }),
  userDetail: (payload) => ({ type: actionTypes.UserDetail, payload }),
  userDetailSuccess: (payload) => ({
    type: actionTypes.UserDetailSuccess,
    payload,
  }),
  userDetailSuccessRefreshed: (payload) => ({
    type: actionTypes.UserDetailSuccessRefreshed,
    payload,
  }),
  switchRole: (payload) => ({ type: actionTypes.SwitchRole, payload }),
  userPlans: (payload) => ({ type: actionTypes.UserPlans, payload }),
  userPlansSuccess: (payload) => ({
    type: actionTypes.UserPlansSuccess,
    payload,
  }),
  userSolutions: (payload) => ({ type: actionTypes.UserSolutions, payload }),
  userSolutionsSuccess: (payload) => ({
    type: actionTypes.UserSolutionsSuccess,
    payload,
  }),
  ClearMainFilters: (payload) => ({
    type: actionTypes.ClearMainFilters,
    payload,
  }),
  Clear: (payload) => ({ type: actionTypes.Clear, payload }),
  CheckFiltersState: (payload) => ({
    type: actionTypes.CheckFiltersState,
    payload,
  }),
  ApplySearch: (payload) => ({ type: actionTypes.ApplySearch, payload }),
  clearIncrementFilterStateCounterForCallLogs: (payload) => ({
    type: actionTypes.clearIncrementFilterStateCounterForCallLogs,
    payload,
  }),
  incrementFilterStateCounterForSMSLogs: (payload) => ({
    type: actionTypes.incrementFilterStateCounterForSMSLogs,
    payload,
  }),
  setSwitchToOld: (payload) => {
    return { type: "switch_old_state", payload };
  },
  checkDuplicatedTab: (payload) => {
    return { type: "duplicated_tab_check", payload };
  },
};

export function* getUserDetail(action) {
  let requestURL = API_ENDPOINTS.userDetail;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";

  try {
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.userDetailSuccessRefreshed(response, options.method));
  } catch (error) {}
}

export function* getUserPlans(action) {
  
  let payloadLength = decodeURIComponent(action.payload).length
  let requestURL=''
  if(payloadLength > 3){
    requestURL = API_ENDPOINTS.userPlans+'?include=expired&number_startswith='+action.payload;
  }else{
    requestURL = API_ENDPOINTS.userPlans;
  }
  
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const response = yield call(requestPromise, requestURL, options);
    yield put(actions.userPlansSuccess(response, options.method));
  } catch (error) {}
}

export function* getUserSolutions(action) {
  let requestURL = API_ENDPOINTS.userSolutions;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  options.body = JSON.stringify(action.payload);

  try {
    let response = null;
    if (REACT_APP_MOCK_DATA_ENABLED) {
      response = {
        status: 200,
        solutions: [
          { id: "IBD", name: "Inbound" },
          { id: "IBD_CC", name: "IBD CC" },
          { id: "C2C", name: "C2C" },
          { id: "OTP", name: "OTP" },
          { id: "OBD", name: "OBD" },
          { id: "progressive_dialer", name: "Progressive Dialer" },
          { id: "predictive_dialer", name: "Predictive dialer" },
        ],
      };
    } else {
      response = yield call(requestPromise, requestURL, options);
    }

    yield put(actions.userSolutionsSuccess(response, options.method));
  } catch (error) {}
}

export function* postLoginSocial(action) {
  let requestURL = API_ENDPOINTS.loginSocial;
  let options = {};
  options.headers = createHeaders();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);

  try {
    const response_login = yield call(requestPromise, requestURL, options);
    if (response_login && response_login.status === 200) {
      let authToken = helpers.getAuthToken();
      options.headers = {
        jwtAuthorization: authToken,
        Authorization: "Bearer " + authToken,
      };
      options.body = null;
      options.method = "GET";

      localStorage.setItem("knowlarityUserStatus", "true");
      // yield put(updateUserStatus({selectedStatus : {label:"Available", value:'Available'}, userId: response_login.success.user_id , headers : {  'jwtAuthorization': authToken,
      // Authorization: 'Bearer ' + authToken} }));

      //fetch user details
      requestURL = API_ENDPOINTS.userDetail;
      const response_user = yield call(requestPromise, requestURL, options);
      requestURL = API_ENDPOINTS.userSolutions;
      const response_solutions = yield call(
        requestPromise,
        requestURL,
        options
      );
      requestURL = API_ENDPOINTS.userPlans;
      const response_plans = yield call(requestPromise, requestURL, options);
      yield put(actions.userDetailSuccess(response_user, options.method));
      yield put(
        actions.userSolutionsSuccess(response_solutions, options.method)
      );
      yield put(actions.userPlansSuccess(response_plans, options.method));
      yield put(actions.loginSocialSuccess(response_login, options.method));
    }
    if (response_login && response_login.status !== 200) {
      action.onSuccess(response_login);
    }
    Tracker.event("AUTH", "login", "login-success");
  } catch (error) {
    Tracker.event("AUTH", "login", "login-failed");
    action.onError({
      status: 500,
      error: { message: "Login failed!", log: error },
    });
  }
}

export function* postLogin(action) {
  let requestURL = API_ENDPOINTS.login;
  let options = {};
  options.headers = createHeaders();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);

  try {
    const response_login = yield call(requestPromise, requestURL, options);
    if (response_login && response_login.status === 200) {
      let authToken = helpers.getAuthToken();
      options.headers = {
        jwtAuthorization: authToken,
        Authorization: "Bearer " + authToken,
      };
      options.body = null;
      options.method = "GET";

      localStorage.setItem("knowlarityUserStatus", "true");

      //  yield put(updateUserStatus({selectedStatus : {label:"Available", value:'Available'}, userId: response_login.success.user_id , headers :       {  'jwtAuthorization': authToken,
      //  Authorization: 'Bearer ' + authToken} }));

      //fetch user details
      requestURL = API_ENDPOINTS.userDetail;
      const response_user = yield call(requestPromise, requestURL, options);
      requestURL = API_ENDPOINTS.userSolutions;
      const response_solutions = yield call(
        requestPromise,
        requestURL,
        options
      );
      requestURL = API_ENDPOINTS.userPlans;
      const response_plans = yield call(requestPromise, requestURL, options);
      yield put(actions.userDetailSuccess(response_user, options.method));
      yield put(
        actions.userSolutionsSuccess(response_solutions, options.method)
      );
      yield put(actions.userPlansSuccess(response_plans, options.method));
      yield put(actions.loginSuccess(response_login, options.method));
    }
    if (response_login) {
      action.onSuccess(response_login);
    }
  } catch (error) {
    Tracker.event("AUTH", "login", "login-failed");
    action.onError({
      status: 500,
      error: { message: "Login failed!", log: error },
    });
  }
}

export function* postSSOLogin(action) {
  let requestURL = API_ENDPOINTS.sso_login;
  let options = {};
  options.headers = createHeaders();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);
  try {
    const response_login = yield call(requestPromise, requestURL, options);

    if (response_login && response_login.status === 200) {
      let authToken = response_login.success.token;
      options.headers = {
        jwtAuthorization: authToken,
        Authorization: "Bearer " + authToken,
      };
      options.body = null;
      options.method = "GET";
      requestURL = API_ENDPOINTS.userDetail;
      const response_user = yield call(requestPromise, requestURL, options);
      requestURL = API_ENDPOINTS.userSolutions;
      const response_solutions = yield call(
        requestPromise,
        requestURL,
        options
      );
      requestURL = API_ENDPOINTS.userPlans;
      const response_plans = yield call(requestPromise, requestURL, options);
      if(response_user && response_user["status"] == 200) { response_user["is_sso"] = true; }
      yield put(actions.userDetailSuccess(response_user, options.method));
      yield put(
        actions.userSolutionsSuccess(response_solutions, options.method)
      );
      yield put(actions.userPlansSuccess(response_plans, options.method));
      yield put(actions.loginSuccess(response_login, options.method));
    }
    if (response_login) {
      action.onSuccess(response_login);
    }
    Tracker.event("AUTH", "sso login", "Login Success");
  } catch (error) {
    Tracker.event("AUTH", "sso login", "Login Failed");
    action.onError({
      status: 500,
      error: { message: "Login failed!", log: error },
    });
  }
}

export function* postForgotPassword(action) {
  let requestURL = API_ENDPOINTS.forgotPassword;
  const options = {};
  options.headers = createHeaders();
  options.method = "POST";
  try {
    options.body = JSON.stringify(action.payload);
    const response = yield call(requestPromise, requestURL, options);
    Tracker.event("AUTH", "login", "Forgot Password Success");
    action.onSuccess(response);
  } catch (error) {
    Tracker.event("AUTH", "login", "Forgot Password Error");
    action.onError({
      status: 500,
      error: {
        message:
          "Username doesn't have an associated account. Are you sure you've registered?",
        log: error,
      },
    });
  }
}

export function* postResetPassword(action) {
  let requestURL = API_ENDPOINTS.resetPassword;
  const options = {};
  options.headers = createHeaders();
  options.method = "POST";
  try {
    options.body = JSON.stringify(action.payload);
    const response = yield call(requestPromise, requestURL, options);
    Tracker.event(
      "AUTH",
      "login",
      "Password Reset Success",
      "reset-password-success"
    );
    action.onSuccess(response);
  } catch (error) {
    Tracker.event(
      "AUTH",
      "login",
      "Password Reset Error",
      "reset-password-error"
    );
    action.onError({
      status: 500,
      error: { message: "Reset Password failed!", log: error },
    });
  }
}

export function* getChangePassword(action) {
  let requestURL = API_ENDPOINTS.changePassword;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.headers = {...options.headers , "Content-Type": "application/x-www-form-urlencoded"}

  options.method = "POST";
  try {
    options.body = action.payload;
    const response = yield call(requestPromiseObj, requestURL, options);
    if(response.status === "success") {
      Tracker.event(
        "AUTH",
        "password change",
        "Change password Success",
        "change-password-success"
      );
      action.onSuccess(response.message ? response.message : "Password changed successfully !");
    } else {
      Tracker.event(
        "AUTH",
        "password change",
        "Change password Error",
        "change-password-error"
      );
      action.onError(response.message ? response.message : "Change Password failed!");
    }
  } catch (error) {
    Tracker.event(
      "AUTH",
      "password change",
      "Change password Error",
      "change-password-error"
    );
    action.onError(error.message ? error.message : "Change Password failed!");
  }
}

export function* saga() {
  yield takeLatest(actionTypes.Logout, () => {});
  yield takeLatest(actionTypes.SSOLogin, postSSOLogin);
  yield takeLatest(actionTypes.Login, postLogin);
  yield takeLatest(actionTypes.LoginSocial, postLoginSocial);
  yield takeLatest(actionTypes.ForgotPassword, postForgotPassword);
  yield takeLatest(actionTypes.ResetPassword, postResetPassword);
  yield takeLatest(actionTypes.UserDetail, getUserDetail);
  yield takeLatest(actionTypes.UserPlans, getUserPlans);
  yield takeLatest(actionTypes.UserSolutions, getUserSolutions);
  yield takeLatest(actionTypes.ChangePassword, getChangePassword);
}
